import { SubscriptionDetails } from "./SubscriptionDetails";

export default function SubscriptionSettings({
  user,
  setShouldShowCancelSubscriptionModal,
}) {
  function renderSubscriptionDetails() {
    if (user?.account?.isTeamsCustomer) {
      return (
        <p className="text-secondary text-xs md:text-sm">
          You are currently using a paid team account which is managed
          by someone else. Please contact them if you need to make any
          changes to your subscription.
        </p>
      );
    } else if (user?.account?.isStudent) {
      return (
        <p className="text-secondary text-xs md:text-sm">
          {user?.account?.accountDetails?.nextBillingDate}
        </p>
      );
    } else {
      return (
        <SubscriptionDetails
          user={user}
          setShouldShowCancelSubscriptionModal={
            setShouldShowCancelSubscriptionModal
          }
        />
      );
    }
  }

  return (
    <div className="flex-1 flex flex-col gap-md">
      {renderSubscriptionDetails()}
    </div>
  );
}
